import React, { useState } from 'react'

import { Button, Dialog, Grid, Icon, Typography, FormHelperText } from '@material-ui/core'

import Scrollbars from "rc-scrollbars";
import CloseIcon from '@material-ui/icons/Close';

import useStyles from "./styles";
import { InputBaseField } from '../../../../components/InputField/InputField';
import { PostDataAPI } from '../../../../Services/APIService';
import { formatDate, formateMdnNumber } from '../../../../components/Common/Extensions';
import { withSnackbar } from "./../../../../components/Message/Alert";
import DialogLoader from '../../../../components/Loader/DialogLoader';
function CallForward({ dialogOpenClose, handleClose,handleSuccessClose, ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    const [errorMessages, setErrorMessages] = useState({ errorPhoneLength: false
    })
    const [isLoading, setIsLoading] = useState(false);
    const [accountNumber, setAccountNumber] = useState(props.accountNumber);
    const [mdnNumber, setMdnNumber] = useState(props.mdnNumber);
    const [wirelessId, setWirelessId] = useState(props.wirelessId);
    const [forwardNumber, setForwardNumber] = useState('');

    const handlePhoneChange = e => {

        if (e.nativeEvent.data != "e") {

            if (e.nativeEvent.data != null || e.target.value != "") {
                // for fomatting
                const re = /^[0-9\b]+$/;
                e.target.value = e.target.value.replace(' ', '').replace('(', '').replace(')', '').replace('-', '');
                const { name, value } = e.target;
                if ((e.target.value === '' || re.test(e.target.value))) {

                    var cleaned = ('' + e.target.value).replace(/\D/g, '')
                    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
                    if (match) {
                        var intlCode = (match[1] ? '+1 ' : ''),
                            number = [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');

                        setForwardNumber(number);
                        return;
                    }

                    setForwardNumber(number);
                }
                else {
                    if (!re.test(e.target.value)) {
                        e.preventDefault();
                    }

                }
            }
            else {

                const { name, value } = e.target;
                setForwardNumber(value);

                if (e.target.value != "") {

                    setErrorMessages(prevState => ({
                        ...prevState,
                        errorPhoneLength: true
                    }));
                }
                
            }
        }
        else
            e.preventDefault();
    }

    const farwardToPhoneNumber =()=> {
        let errorList = [];
        if (!forwardNumber || forwardNumber.length < 10) {

            setErrorMessages(prevState => ({
                ...prevState,
                errorPhoneLength: true
            }));

            errorList.push(true);

        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPhoneLength: false
            }));
        }
        if (forwardNumber && forwardNumber == formateMdnNumber(props.mdnNumber)) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorForwardToNumber: true
            }));

            errorList.push(true);
        } else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorForwardToNumber: false
            }));
        }
        if (errorList.length < 1) {
            var obj = {
                wirelessId: wirelessId,
                accountNumber: accountNumber,
                userName: props.accountName,
                MDN: mdnNumber,
                lineUserName: props.lineUserName,
                forwardToNumber: forwardNumber,
                referenceNumber: accountNumber + '_' + mdnNumber + '_' + Math.floor(Math.random() * 99999).toString(),
                callbackURL: '',
                loginUserName: props.loginUserName,

            };
            setIsLoading(true)
            PostDataAPI("telispire/forwardToPhoneNumber", obj,true).then((result) => {
                setIsLoading(false)
                if (result.success && result.data != null) {
                    handleSuccessClose("Call forwarding request received; forwarding will commence in 30 minutes.");
                } else {
                    showMessage("Error", "Forwarding to the specified phone number failed.", "error", 3000);
                }
            })
        }
    }

    return (
        <Dialog
            classes={{ paper: classes.dialogPaper }}
            disableEscapeKeyDown
            open={dialogOpenClose}
            maxWidth="lg"
            {...props} >
            <div className={classes.dialogContent}>
                <div className={classes.box}>
                    <div className={classes.header} id="draggable-dialog-title">
                        {/* <FormGroupTitle>Figgers Coverage</FormGroupTitle> */}
                        <Typography className={classes.title}>Call forward</Typography>
                        <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                        {/* <span className={classes.crossButton} onClick={handleClose}><img src={CloseIcon} alt="close" /></span> */}
                    </div>
                    {isLoading ? <DialogLoader></DialogLoader> : ''}
                    <div className={classes.content}>
                        <Scrollbars autoHeight autoHeightMin={150} autoHeightMax={600}>
                            <Grid container direction="column">
                                <Grid item lg={12}>
                                    <Typography className={classes.labelText}>Phone number</Typography>
                                </Grid>
                                <Grid item lg={12}>
                                    <Typography className={classes.valueText}>{formateMdnNumber(props.mdnNumber)}</Typography>
                                </Grid>
                                <Grid item lg={12}>
                                    <Typography className={classes.labelText}>Forward to Number</Typography>
                                    <b>Enter Number</b>
                                </Grid>
                            
                                <Grid item lg={12}>
                                    <InputBaseField
                                        id="fowardNumber"
                                        name="fowardNumber"
                                        type="text"
                                        value={forwardNumber}
                                        onChange={handlePhoneChange}
                                        placeholder='Enter Number'
                                        IsDisabled={false}
                                        MaxLength='14'
                                    />
                                    
                                    {errorMessages.errorPhoneLength && (!forwardNumber || forwardNumber.length < 10) ? (<FormHelperText style={{ color: "red" }} >
                                        Enter valid forward phone number
                                    </FormHelperText>) : ('')}
                                    {errorMessages.errorForwardToNumber && (forwardNumber && forwardNumber == formateMdnNumber(props.mdnNumber)) ? (<FormHelperText style={{ color: "red" }} >
                                        Forward Number should be different from existing number
                                    </FormHelperText>) : ('')}
                                   
                                </Grid>
                            </Grid>
                        </Scrollbars>
                    </div>
                    <div className={classes.footer}>

                        <div className={classes.footerRight}>

                            <Button className={classes.backBtn} onClick={handleClose}>Close</Button>

                            {isLoading ?
                                <Button className={classes.changeBtn}>Set call forwarding</Button>
                                :
                                <Button className={classes.changeBtn} onClick={farwardToPhoneNumber}>Set call forwarding</Button>
                            }
                            

                        </div>
                    </div>
                </div>
            </div>
        </Dialog >
    )
}

export default withSnackbar(CallForward);